import type { TemplateStudioDraft } from "@/lib/template-studio/draft/templateStudioDraft";

export interface SaveTemplateModalSummary {
  blockCount: number;
  configurableSectionCount: number;
  heraldTurnCount: number;
}

const resolveTemplateStudioBlockCount = (
  draft: TemplateStudioDraft,
): number => {
  const rootElement = draft.spec.elements[draft.spec.root];
  return rootElement?.children?.length ?? 0;
};

/** Kept out of `SaveTemplateModal` so Template Studio can build it without loading the lazy modal. */
export const resolveSaveTemplateModalSummary = (
  draft: TemplateStudioDraft,
  heraldTurnCount: number,
): SaveTemplateModalSummary => ({
  blockCount: resolveTemplateStudioBlockCount(draft),
  configurableSectionCount: draft.slots.length,
  heraldTurnCount,
});
